import { z } from "zod"

// Version 1 ---------------------

export const BadgeElementV1 = z.object({
  id: z.string(),
  name: z.literal("badge"),
})

export type TBadgeElementV1 = z.infer<typeof BadgeElementV1>

// Latest ---------------------
export const BadgeElement = BadgeElementV1
export type TBadgeElement = TBadgeElementV1
